const getCredentials = () => ({
  CLIENT_ID: '58bca560354b42ec8191c0733acea4f9',
  CLIENT_SECRET: '1b9facf262d44af29c6a45c8a8ddbd67',
});

export default getCredentials;
